<template>
  <v-navigation-drawer
    v-model="drawer"
    enable-resize-watcher
    temporary
    app
    right
  >
    <v-list>
      <v-list-item>
        <v-list-item-title class="font-weight-bold">
          Annual Review History
        </v-list-item-title>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item
        exact
        value="true"
        :to="getLink(item)"
        v-for="(item, i) in items"
        :key="i"
      >
        <v-list-item-content>
          <v-list-item-title>
            <template v-if="item.complete">
              {{ item.annualReviewEndDate | longDate }}
            </template>
            <template v-else>
              Current Annual Review
            </template>
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon v-if="item.id == annualreview.id">
          <v-icon>check</v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AnnualReviewNavigationDrawer",
  components: {},
  data: () => ({
    clipped: true,
    miniVariant: false
  }),
  computed: {
    drawer: {
      get() {
        return this.annualreview_drawer;
      },
      set(val) {
        this.$store.dispatch("annualreview/setDrawer", val);
      }
    },
    items() {
      return this._.orderBy(this.history, ["annualReviewStartDate"], ["desc"]);
    },
    ...mapGetters({
      history: "annualreview/history",
      annualreview: "annualreview/annualreview",
      annualreview_drawer: "annualreview/drawer"
    })
  },
  methods: {
    getLink(item) {
      return `/annual-reviews/${item.user.id}/${item.id}/coreboard`;
    }
  }
};
</script>
